import { makeStyles } from "@material-ui/styles"

export default makeStyles({
  logoutButton: {
    padding: "20px",
  },
})
